module.exports = __webpack_public_path__ + "img/hint-two-mobile.47a01f55.png";